import gql from "graphql-tag";

export const basketForUserQuery = gql`
    query basketForUser($basketId: ID!) {
        basket(basketId: $basketId) {
            items {
                product {
                    # id: ID!
                    id
                    # title: String!
                    title
                }
                # amount: Int! -> this is the quantity of the product in the basket
                amount
            }
        }
    }
`;

export const addBasketItemMutation = gql`
    mutation ($BasketId: ID!, $Amount: Float!, $ProductId: ID!) {
        basketAddItem(basketId: $BasketId, amount: $Amount, productId: $ProductId) {
            # id: ID! -> id of the basket/cart
            id
            items {
                # id: ID!
                id
                # amount: Int! -> this is the quantity of the product in the basket
                amount
            }
        }
    }
`;

//only used by fdi
export const addPriceRequest = gql`
    mutation ($articleId: ID!) {
        addPriceRequest(articleId: $articleId) {
            # id: ID!
            id
        }
    }
`;

export const getArticleShopInfos = gql`
    query ($articleId: ID!) {
        article(articleId: $articleId) {
            # id: ID!
            id
            price {
                # price: Float!
                price
                currency {
                    # sign: String!
                    sign
                }
            }
            stock {
                # stock: Float!
                stock
                # stockStatus: Int! -> Value can be one of: 0 -> (green) deliverable 1 -> (orange) deliverable, but only a few left -1 -> (red) not stock
                stockStatus
            }
            # showPriceOnRequest: Boolean!
            showPriceOnRequest
        }
    }
`;

// only used by sw
export const getBasketId = gql`
    query ($userId: ID!) {
        currentBasketIdFromUserId(userId: $userId) {
            basketId
        }
    }
`;
